import React from "react";
import Grid from "@mui/material/Grid";
import { Link } from "react-router-dom";
import Typography from "@mui/material/Typography";
import {useTheme} from "@mui/material/styles";
import {useTranslation} from "react-i18next";

export default function About() {
    const theme = useTheme();
    const {t} = useTranslation();

    return (
        <Grid
            id="home-container"
            container
            columnSpacing={4}
            sx={{padding: theme.spacing(8, 2), whiteSpace: "pre-line"}}
        >
            <Grid item xs={12}>
                <Typography
                    variant="h3"
                    gutterBottom
                >{t('about.Header')}</Typography>
            </Grid>
            <Grid item xs={8}>
                <Typography variant="body1">
                    {t('about.KilabDescription')}
                </Typography>
            </Grid>
            <Grid item xs={6} md={6} sx={{padding: theme.spacing(4, 0)}}>
                <Grid item xs={12}>
                    <Typography variant="h5" gutterBottom>
                        {t('about.KndHeader')}
                    </Typography>
                </Grid>
                <Typography variant="body1">
                    {t('about.KndDescription')}
                </Typography>
            </Grid>
            <Grid item xs={6} md={6} sx={{padding: theme.spacing(4, 0)}}>
                <Grid item xs={12}>
                    <Typography variant="h5" gutterBottom>
                        {t('about.ConceptHeader')}
                    </Typography>
                </Grid>
                <Typography variant="body1">
                    {t('about.ConceptDescription')}
                </Typography>
            </Grid>
            <Grid
                container
                sx={{
                    padding: theme.spacing(2),
                    backgroundColor: theme.palette.background.paper,
                }}
            >
                <Grid item xs={12}>
                    <Typography variant="h3">{t('about.Promotion')}</Typography>

                    <Typography variant="body1">{t('about.PromotionDescription')}</Typography>
                </Grid>
                <Grid
                    item
                    xs={3}
                    md={2}
                    lg={2}
                    sx={{padding: theme.spacing(4, 0), marginTop: theme.spacing(10)}}
                >
                    <img
                        src="https://klima-neutral-digital.de/wp-content/themes/knd/assets/img/logo-mittelstand-digital.png"
                        alt="Logo Mittelstand Digital"
                        width="60%"
                    />
                </Grid>
                <Grid item xs={6} md={4} lg={2} sx={{padding: theme.spacing(4, 0)}}>
                    <img
                        src="https://klima-neutral-digital.de/wp-content/themes/knd/assets/img/kmwk.png"
                        alt="Logo Bundesministerium für Wirtschaft und Klimaschutz"
                    />
                </Grid>
                <Grid item xs={6} md={4} lg={2} sx={{padding: theme.spacing(4, 0), marginTop: theme.spacing(10)}}>
                    <img
                        src="https://kilab-ee.zsw-bw.de/info/wp-content/uploads/2025/01/IW-RGB-768x167.png"
                        alt=''
                        style={{maxHeight: "60px"}}
                    />
                </Grid>
                <Grid item xs={6} md={4} lg={3} sx={{padding: theme.spacing(4, 0), marginTop: theme.spacing(10)}}>
                    <Link href="https://european-digital-innovation-hubs.ec.europa.eu/edih-catalogue/edih-aics" target="_blank" rel="noopener">
                        <img
                            src='https://kilab-ee.zsw-bw.de/info/wp-content/uploads/2025/01/2023-04-06_EDIH_AICS_Logo-300x110.png'
                            alt='EDIH AICS Logo'
                            style={{maxHeight: "100px"}}
                        />
                    </Link>
                </Grid>
                <Grid item xs={6} md={4} lg={3} sx={{padding: theme.spacing(4, 0), marginTop: theme.spacing(10)}}>
                    <Link href="https://european-digital-innovation-hubs.ec.europa.eu/edih-catalogue/edih-aics" target="_blank" rel="noopener">
                        <img
                            src='https://kilab-ee.zsw-bw.de/info/wp-content/uploads/2025/01/2023-04-06_EDIH_AICS_Foerderlogo_EU_Querformat-300x96.jpg'
                            alt='Co-funded by the European Union Logo'
                            style={{maxHeight: "60px"}}
                        />
                    </Link>
                </Grid>

                {theme.abbreviation === "MDZ" ? (
                    <Grid item xs={5} md={5} sx={{padding: theme.spacing(4, 0)}}>
                        <Typography variant="h5" gutterBottom>
                            {t('about.MdzHeader')}
                        </Typography>
                        <Typography variant="body1">
                            {t('about.MdzDescription')}
                        </Typography>
                    </Grid>
                ) : null}
            </Grid>
            <Grid container sx={{padding: theme.spacing(5)}}>
                <Grid item xs={12}>
                    <Typography variant="h3">Kontakt</Typography>
                </Grid>
                <Grid item xs={12} md={12} sx={{padding: theme.spacing(4, 0)}}>
                    <Typography variant="h5" gutterBottom>
                        Bei Rückfragen oder anderem Feedback wenden Sie sich gerne an
                    </Typography>
                </Grid>
                <Grid item xs={3} md={3}>
                    <Typography variant="body1">
                        Katharina Strecker (she/her)
                        <br/>
                        E-Mail:
                        <a href="mailto:katharina.strecker@zsw-bw.de">
                            katharina.strecker@zsw-bw.de
                        </a>
                    </Typography>
                </Grid>
                <Grid item xs={3} md={3}>
                    <Typography variant="body1">
                        Kai Binder (he/him)
                        <br/>
                        E-Mail:
                        <a href="mailto:kai.binder@zsw-bw.de">kai.binder@zsw-bw.de</a>
                    </Typography>
                </Grid>
                 <Grid item xs={3} md={3}>
                    <Typography variant="body1">
                        Jessica Hofmann (she/her)
                        <br/>
                        E-Mail:
                        <a href="mailto:jessica.hofmann@zsw-bw.de">jessica.hofmann@zsw-bw.de</a>
                    </Typography>
                </Grid>
            </Grid>
        </Grid>
    );
}
